import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h3","key":"svg-2"}],["path",{"d":"M16 16v.01","key":"svg-3"}],["path",{"d":"M16 21l5 -5","key":"svg-4"}],["path",{"d":"M21 21v.01","key":"svg-5"}]]

const IconFilter2Discount = createReactComponent('outline', 'filter-2-discount', 'Filter2Discount', __iconNode);

export default IconFilter2Discount;